import { defineStore } from 'pinia'
import { ref } from 'vue'
import type { Character } from '@/types'

export const useCharacterStore = defineStore('characterStore', () => {
  const extraCharacters = ref<Character[]>([])

  function addExtraCharacter(character: Character) {
    extraCharacters.value.push(character)
  }

  function characterExist(name: string): boolean {
    return extraCharacters.value.some(char => char.charName === name)
  }

  function getCharacterByName(name: string): Character | undefined {
    return extraCharacters.value.find(char => char.charName === name)
  }

  return {
    extraCharacters,
    addExtraCharacter,
    getCharacterByName,
    characterExist,
  }
})
